import * as React from "react";
import { TableBody, TableCell, TableHead, TableRow, Stack, Typography, Pagination, Button, useTheme, Box } from "@mui/material";
import SearchTxtField from "../../../components/SearchTxtField";
import route from "../../../utils/Routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import StyledTableContainer from "../../../components/StyledTableContainer";
import { useState } from "react";
import { getProjByComServ } from "../../../services/proj-service";
import { formatDateWithJs, isNotEmpty } from "../../../utils/format";
import { useAuthContext } from "../../../context/AuthContext";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import { Add } from "@mui/icons-material";
import constants from "../../../utils/Constants";


const columns = [
    {
        id: 'projName',
        label: "Project Name",
        align: 'left',
        minWidth: 150,
    },
    {
        id: 'actProjIdStrg',
        label: "Project ID",
        align: 'left',
        minWidth: 150,
    },
    {
        id: 'siteLocation',
        label: "Site Location",
        align: 'left',
        minWidth: 150,
    },
    {
        id: 'cAt',
        label: "Created On",
        align: 'left',
        minWidth: 150,
    },
];
function ProjList({ aComId, type = 'amtc' }) {
    const navigate = useNavigate();
    const theme = useTheme();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const limit = type === 'amtc' ? 7 : 10;
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const comId = type === 'amtc' ? aComId : ctxtUser?.comId;

    const { isLoading, isError, error, data: projData } = useQuery([QueryKey.projList, pgNo, comId, ctxtUser?.userId, isSrchBtnClick],
        () => getProjByComServ({ comId, limit, pageNumber: pgNo, searchWord, type, userId: ctxtUser?.userId, userType: ctxtUser?.userType }), {
        enabled: isNotEmpty(comId),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            return prev
        }, { replace: true })
    }

    const handleRowClick = (projIdStrg) => {
        if (type === "amtc")
            navigate(`${route.aProjectinfo}/?projId=${projIdStrg}`);
        else
            navigate(`${route.cProjInfo}/?projId=${projIdStrg}`);
    };
    function handleAddProjClick() {
        navigate(route.aCreateProj, { state: { comId } });
    };

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }
    return (
        <Box height={type === 'amtc' ? "90%" : "100%"} width={"100%"} px={type === 'amtc' ? 2 : 0}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1, pl: 1, pr: 3 }} width={"100%"}>
                <Stack width={"33%"} >
                    <Typography sx={{ fontSize: 18, fontWeight: 500, }}>Project List</Typography>
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                    <SearchTxtField handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder="Search Project By Name & Id..." />
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                    {ctxtUser?.userType === constants.admin && <Button variant='outlined' onClick={handleAddProjClick} startIcon={<Add />} sx={{
                        fontSize: 13, ml: 5,
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Create Project</Button>}
                </Stack>
            </Stack>

            {projData && <StyledTableContainer height={"81%"} isStickyHeader={true}>
                <TableHead>
                    <TableRow >
                        {columns.map((column) => (
                            <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(projData?.projArr || []).map((i) => {
                        return (
                            <React.Fragment key={i?.id}>
                                <TableRow hover tabIndex={-1} onClick={() => handleRowClick(i?.projIdStrg)}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50, cursor: 'pointer' }} >
                                    {columns.map((column) => {
                                        const value = i[column.id];
                                        switch (column.id) {
                                            case "cAt":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {formatDateWithJs(value)}
                                                </TableCell>
                                            default:
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {(value === null || value === "" || value === "null") ? "NA" : value}
                                                    </TableCell>
                                                );
                                        }
                                    })}
                                </TableRow>
                            </React.Fragment>
                        );
                    })}
                </TableBody>
            </StyledTableContainer>}
            <Stack sx={{ alignItems: "center", mt: 2 }}>
                <Pagination count={Math.ceil(projData?.totalProjCount / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
                    variant="outlined" shape="rounded" />
            </Stack>
        </Box>
    );
}

export default ProjList